import { t } from 'i18next';

export const REMOVE_FILTER_SELECT = {
  label: 'components.input_select_remove_filter',
  value: ''
};

export const EMPTY_SELECT = {
  label: t('components.input_select_empty'),
  value: ' '
};

export const GENDER = [
  { label: t('MALE'), value: 'M' },
  { label: t('FEMALE'), value: 'F' },
  { label: t('UNDEFINED'), value: 'U' }
];

export const registries = {
  data: [],
  isSearching: false,
  totalCount: 0
};

export const defaultParams = (length: number) => ({
  page: 0,
  length
});

export const DEFAULT_PARAMS = {
  page: 0,
  length: 10
};

export const DEFAULT_REGISTRIES = {
  data: [],
  isSearching: false,
  totalCount: 0
};

export * from './apis';
export * from './inputRules';
export * from './permissions';
